import Vue from 'vue';

function getPreviewEl (el) {
    const previewElClass = 'v-md-editor-preview';

    return el.classList.contains(previewElClass) ? el : el.querySelector(`.${previewElClass}`);
}

const mountComp = (ele, compName, propsData) => {
    if (propsData && compName) {
        let Comp = Vue.component(compName);
        if (!Comp) {
            throw new Error(`Component ${compName} not found`);
        }
        // 组件初始化时传入绑定数据（propsData只能用于初始化，复发响应式）
        let comp = new Comp({ propsData });
        comp.$mount(ele);
    } else {
        ele.innerText = '未识别数据';
    }
};

export default function createModelEmergencyPlugin () {
    async function handleMdChange () {
        if (typeof window === 'undefined') return;

        await this.$nextTick();

        const previewEl = getPreviewEl(this.$el);
        const eles = previewEl.querySelectorAll('.v-md-pre-wrapper-gpt-chatbox-emergency');
        if (!eles.length) return;

        let ele = eles[0];
        if (!ele || !ele.innerText) return;

        try {
            let text = ele.innerText;
            ele.innerText = '';

            console.info('应急指挥：', text);

            let json = JSON.parse(text);

            // 打开网页
            if (json.type === 'pop' && !!json.url) {
                mountComp(ele, 'gpt-chart-page', { value: json.url });
                return;
            } else if (json.type === 'mp4' && !!json.url) {
                // 打开视频
                mountComp(ele, 'gpt-chart-video', { value: json.url, text: json.text });
                return;
            }
        } catch (err) {
            console.error(err);
            ele.innerText = '分析过程中出现错误';
        }
    }

    return {
        install (VMdEditor) {
            if (!VMdEditor.mixins) VMdEditor.mixins = [];

            VMdEditor.mixins.push({
                watch: {
                    value: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    text: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    currentMode: handleMdChange
                }
            });
        }
    };
};
